import {
  DialogBackdrop,
  DialogPanel,
  Dialog as HeadlessUiDialog,
} from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/solid"

interface Props {
  children: React.ReactNode
  onClose: () => void
  open: boolean
}

export default function Dialog({ children, open, onClose }: Props) {
  return (
    <HeadlessUiDialog className="relative z-50" open={open} onClose={onClose}>
      <DialogBackdrop className="fixed inset-0 bg-black/30" />

      <div className="fixed inset-0 w-screen overflow-y-auto p-4">
        <div className="flex min-h-full items-center justify-center">
          <DialogPanel className="max-w-lg rounded-3xl border bg-white p-4 pb-6 shadow">
            <button
              className="rounded-full text-custom-black hover:opacity-80"
              onClick={onClose}
              type="button"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>

            {children}
          </DialogPanel>
        </div>
      </div>
    </HeadlessUiDialog>
  )
}
